<template>
    <div id="Breadcrumbs" :class='[breadcrumbWidthClass]'>
        <a v-for="(breadcrumb, index) in breadcrumbList"
          :key="index"
          @click.prevent="routeTo(index)"
          :class="{'linked': !!breadcrumb.link}">
          <span> {{ breadcrumb.name }} </span>
          <span v-if="index < breadcrumbList.length - 1">/</span>
        </a>
    </div>
</template>

<script>
  export default {
    name: 'Breadcrumbs',
    data () {
      return {
        breadcrumbList: []
      }
    },
    mounted () {
      this.updateList()
    },
    computed:{
        breadcrumbWidthClass(){
            return this.$route.meta.activeModule == 'PowerScan' ? 'col-3 d-none d-sm-block' : 'col-12'
        }
    },
    watch: {
      '$route' () {
        this.updateList()
      }
    },
    methods: {
      routeTo (routeTo) {
        if ( this.breadcrumbList[routeTo].link ) {
          this.$router.push(this.breadcrumbList[routeTo].link)
        }
      },
      updateList () {
        this.breadcrumbList = this.$route.meta.breadcrumb
      }
    }
  }
</script>
